import axios from 'axios';

import {
  CustomerDepositListResponseData,
  CustomerDepositParams,
} from 'root/apps/QuoteMachineIntegration/state/CustomerDepositResponse';
import { datadogRum } from 'root/datadog/datadogRum';

import { LS_INVOICING_API_ROOT } from '../constants';

export default class CustomerDepositService {
  static async fetchCustomerDeposits(
    creditAccountId: string,
    params: CustomerDepositParams
  ): Promise<CustomerDepositListResponseData> {
    try {
      const invoicingCreditAccountId = `ls-retail_${creditAccountId}`;

      const { data } = await axios.get<CustomerDepositListResponseData>(
        `${LS_INVOICING_API_ROOT}/credit-accounts/${invoicingCreditAccountId}/credit-memos`,
        {
          params: {
            page: params.page,
            limit: params.limit,
          },
        }
      );

      return data;
    } catch (error) {
      datadogRum.addError(error as Error, {
        creditAccountId,
        params,
        message: `Failed to fetch customer deposits for credit account ${creditAccountId} with params ${JSON.stringify(
          params
        )}`,
      });
      throw error;
    }
  }
}
